// API Configuration
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || import.meta.env.REACT_APP_BACKEND_URL;

export const API_BASE_URL = BACKEND_URL;
export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: `${BACKEND_URL}/api/auth`,
  
  // Admin endpoints
  ADMIN: `${BACKEND_URL}/api/admin`,
  
  // Member endpoints  
  MEMBER: `${BACKEND_URL}/api/member`,
  
  // PIF endpoints
  PIF: `${BACKEND_URL}/api/pif`,
  
  // Public endpoints
  PUBLIC: `${BACKEND_URL}/api`
};

export default API_ENDPOINTS;